const state = {
  currentCurrency: 'GBP',
};

const mutations = {
  UPDATE_CURRENCY(state, currency) {
    state.currentCurrency = currency;
  },
};

const actions = {
  GET_CURRENCY({ commit }) {
    return axios
      .get('/json/currency')
      .then((response) => {
        if (response.status === 200) {
          commit('UPDATE_CURRENCY', response.data.currency);
        } else {
          throw 'There was a problem getting the current currency.';
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  SET_CURRENCY({ commit }, currency) {
    return axios
      .post('/json/currency', {
        currency: currency,
      })
      .then((response) => {
        if (response.status === 200) {
          commit('UPDATE_CURRENCY', response.data.currency);
        } else {
          throw 'There was a problem setting the currency.';
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
